export async function isUsableAktPdfBlob(blob: Blob | null | undefined): Promise<boolean> {
   if (!blob || blob.size < 8) {
      return false;
   }
   const head = (await blob.slice(0, 8).text()).trimStart();
   return head.startsWith("%PDF");
}
